import {NgModule} from "@angular/core";
import {FrameworkModule} from "../framework/framework.module";
import {CustomObjectTypeSearchPageComponent} from "./custom-object-type/custom-object-type-search-page/custom-object-type-search-page.component";
import {CustomObjectSearchPageComponent} from "./custom-object/custom-object-search-page/custom-object-search-page.component";
import {MembershipTypeCustomObjectSearchPageComponent} from "./custom-object/custom-object-search-page/membership-type-custom-object-search-page.component";
import {ProductLineCustomObjectSearchPageComponent} from "./custom-object/custom-object-search-page/product-line-custom-object-search-page.component";
import {OutletCustomObjectSearchPageComponent} from "./custom-object/custom-object-search-page/outlet-custom-object-search-page.component";
import {InventoryCustomObjectSearchPageComponent} from "./custom-object/custom-object-search-page/inventory-custom-object-search-page.component";
import {CustomObjectTypeEditPageComponent} from "./custom-object-type/custom-object-type-edit-page/custom-object-type-edit-page.component";
import {SharedModule} from "../shared/shared.module";
import {CustomObjectSharedModule} from "./custom-object.shared.module";
import {CustomObjectEditPageComponent} from "./custom-object/custom-object-edit-page/custom-object-edit-page.component";
import {InventoryCustomObjectTypeSearchPageComponent} from "./custom-object-type/custom-object-type-search-page/inventory-custom-object-type-search-page.component";
import {MembershipTypeCustomObjectTypeSearchPageComponent} from "./custom-object-type/custom-object-type-search-page/membership-type-custom-object-type-search-page.component";
import {ProductLineCustomObjectTypeSearchPageComponent} from "./custom-object-type/custom-object-type-search-page/product-line-custom-object-type-search-page.component";
import {OutletCustomObjectTypeSearchPageComponent} from "./custom-object-type/custom-object-type-search-page/outlet-custom-object-type-search-page.component";
import {MembershipTypeCustomObjectEditPageComponent} from "./custom-object/custom-object-edit-page/membership-type-custom-object-edit-page.component";
import {ProductLineCustomObjectEditPageComponent} from "./custom-object/custom-object-edit-page/product-line-custom-object-edit-page.component";
import {OutletCustomObjectEditPageComponent} from "./custom-object/custom-object-edit-page/outlet-custom-object-edit-page.component";
import {InventoryCustomObjectEditPageComponent} from "./custom-object/custom-object-edit-page/inventory-custom-object-edit-page.component";
import {MembershipTypeCustomObjectTypeEditPageComponent} from "./custom-object-type/custom-object-type-edit-page/membership-type-custom-object-type-edit-page.component";
import {ProductLineCustomObjectTypeEditPageComponent} from "./custom-object-type/custom-object-type-edit-page/product-line-custom-object-type-edit-page.component";
import {OutletCustomObjectTypeEditPageComponent} from "./custom-object-type/custom-object-type-edit-page/outlet-custom-object-type-edit-page.component";
import {InventoryCustomObjectTypeEditPageComponent} from "./custom-object-type/custom-object-type-edit-page/inventory-custom-object-type-edit-page.component";
import {ReportsSharedModule} from "../reports/reports.shared.module";

@NgModule({
    imports: [
        SharedModule,
        FrameworkModule,
        CustomObjectSharedModule,
        ReportsSharedModule
    ],
    declarations: [
        CustomObjectEditPageComponent,
        MembershipTypeCustomObjectEditPageComponent,
        ProductLineCustomObjectEditPageComponent,
        OutletCustomObjectEditPageComponent,
        InventoryCustomObjectEditPageComponent,

        CustomObjectSearchPageComponent,
        MembershipTypeCustomObjectSearchPageComponent,
        ProductLineCustomObjectSearchPageComponent,
        OutletCustomObjectSearchPageComponent,
        InventoryCustomObjectSearchPageComponent,


        CustomObjectTypeEditPageComponent,
        MembershipTypeCustomObjectTypeEditPageComponent,
        ProductLineCustomObjectTypeEditPageComponent,
        OutletCustomObjectTypeEditPageComponent,
        InventoryCustomObjectTypeEditPageComponent,

        CustomObjectTypeSearchPageComponent,
        MembershipTypeCustomObjectTypeSearchPageComponent,
        ProductLineCustomObjectTypeSearchPageComponent,
        OutletCustomObjectTypeSearchPageComponent,
        InventoryCustomObjectTypeSearchPageComponent
    ],
    exports: [
        CustomObjectEditPageComponent,
        MembershipTypeCustomObjectEditPageComponent,
        ProductLineCustomObjectEditPageComponent,
        OutletCustomObjectEditPageComponent,
        InventoryCustomObjectEditPageComponent,

        CustomObjectSearchPageComponent,
        MembershipTypeCustomObjectSearchPageComponent,
        ProductLineCustomObjectSearchPageComponent,
        OutletCustomObjectSearchPageComponent,
        InventoryCustomObjectSearchPageComponent,


        CustomObjectTypeEditPageComponent,
        MembershipTypeCustomObjectTypeEditPageComponent,
        ProductLineCustomObjectTypeEditPageComponent,
        OutletCustomObjectTypeEditPageComponent,
        InventoryCustomObjectTypeEditPageComponent,

        CustomObjectTypeSearchPageComponent,
        MembershipTypeCustomObjectTypeSearchPageComponent,
        ProductLineCustomObjectTypeSearchPageComponent,
        OutletCustomObjectTypeSearchPageComponent,
        InventoryCustomObjectTypeSearchPageComponent
    ]
})
export class CustomObjectModule {
}
